import AmountMode from '@/App/tiles/TargetAccumulator/AmountMode.tsx';
import { ClientWay } from '@/App/tiles/TargetAccumulator/ClientsWay.tsx';
import LeverageAmount from '@/App/tiles/TargetAccumulator/LeverageAmount.tsx';
import LeverageRatio from '@/App/tiles/TargetAccumulator/LeverageRatio.tsx';
import Notional from '@/App/tiles/TargetAccumulator/Notional.tsx';

export const InputGroup1 = () => (
  <>
    <ClientWay />
    <Notional />
    <AmountMode />
    <LeverageRatio />
    <LeverageAmount isSchedule />
  </>
);
